import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Pipe({ name: 'blobToSafeUrl' })
export class BlobToSafeUrlPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}

  transform(blob: Blob): SafeUrl {
    const url = URL.createObjectURL(blob);
    return this.domSanitizer.bypassSecurityTrustUrl(url);
  }
}
